import { useState, useCallback } from 'react';
import { finBillDataApi, LookupItem } from '../../../services/finBillDataApi';

interface LookupData {
  banks: LookupItem[];
  currencies: LookupItem[];
  companies: LookupItem[];
  billSorts: LookupItem[];
}

export function useFinBillDataLookup() {
  const [lookups, setLookups] = useState<LookupData>({
    banks: [],
    currencies: [],
    companies: [],
    billSorts: [],
  });
  const [loaded, setLoaded] = useState(false);

  /** Load all lookup data from backend */
  const loadLookups = useCallback(async () => {
    if (loaded) return;
    try {
      const [banks, currencies, companies, billSorts] = await Promise.all([
        finBillDataApi.lookupBanks(),
        finBillDataApi.lookupCurrencies(),
        finBillDataApi.lookupCompanies(),
        finBillDataApi.lookupBillSorts(),
      ]);
      setLookups({ banks, currencies, companies, billSorts });
      setLoaded(true);
    } catch {
      // Silently fail — lookups optional
    }
  }, [loaded]);

  /** Get name for a code from a lookup list */
  const getLookupName = useCallback((list: LookupItem[], code: string): string => {
    if (!code) return '';
    const item = list.find(i => i.code === code);
    return item?.name || '';
  }, []);

  return { lookups, loadLookups, getLookupName };
}
